"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = _interopRequireDefault(require("baseStyles/enums/fonts"));
var _colors = require("baseStyles/enums/colors");
var _types = require("./types");
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _PositionBox = _interopRequireDefault(require("../Box/PositionBox"));
var _Text = _interopRequireDefault(require("../Text"));
var _FlexBox = _interopRequireDefault(require("../Box/FlexBox"));
var _types2 = require("../Box/FlexBox/types");
var _exclamationIcon = _interopRequireDefault(require("./exclamation-icon.svg"));
var _excluded = ["children", "type", "value", "hasError", "onFocus", "onBlur", "onChange", "onClick", "autoFocus", "dataTestId", "customPlaceholder", "icon", "errorMessage"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var computeValue = function computeValue(value) {
  if (typeof value === "number") {
    return "".concat(value || 0, "px");
  }
  return value;
};
var InputBox = _styledComponents["default"].input.withConfig({
  displayName: "Input__InputBox",
  componentId: "sc-97ww98-0"
})(["font-family:", ";font-style:", ";width:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background:transparent;border:", ";padding:", ";box-sizing:border-box;border-radius:", ";height:", ";", ";:-internal-autofill-selected{color:", " !important;background:transparent;appearance:none;};::placeholder{color:", ";opacity:", ";};", ";&:focus{", "};&:disabled{pointer-events:none;opacity:1;};", ";text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"], _fonts["default"].Family.GRAPHIE, _fonts["default"].Style.NORMAL, function (props) {
  return props.width ? computeValue(props.width) : '100%';
}, function (props) {
  return computeValue(props.fontSize) || "".concat(_fonts["default"].Size.S14, "px");
}, function (props) {
  return props.fontWeight || _fonts["default"].Weight.W400;
}, function (props) {
  return computeValue(props.lineHeight) || "".concat(_fonts["default"].Height.H20, "px");
}, function (props) {
  var _props$theme;
  return props.color || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colorSecondary);
}, function (props) {
  var _props$theme2;
  return computeValue(props.border) || "1px solid ".concat((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.border);
}, function (props) {
  return computeValue(props.padding) || '10px';
}, function (props) {
  return computeValue(props.borderRadius) || '800px';
}, function (props) {
  return props !== null && props !== void 0 && props.height ? props.height + 'px' : 'auto';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.hideBorder) && "\n        border: none;\n    ";
}, function (props) {
  var _props$theme3;
  return props.color || ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.colorSecondary);
}, function (props) {
  var _props$theme4;
  return props.placeholderColor || props.color || ((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.colorSecondary);
}, function (props) {
  return props.placeholderOpacity;
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.outline) && "outline: ".concat(props === null || props === void 0 ? void 0 : props.outline, ";");
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.focusBorder) && "border: ".concat(props === null || props === void 0 ? void 0 : props.focusBorder);
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.backgroundColor) && "background: ".concat(props === null || props === void 0 ? void 0 : props.backgroundColor, ";");
});
var Input = function Input(_ref) {
  var children = _ref.children,
    type = _ref.type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    hasError = _ref.hasError,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    autoFocus = _ref.autoFocus,
    dataTestId = _ref.dataTestId,
    customPlaceholder = _ref.customPlaceholder,
    icon = _ref.icon,
    errorMessage = _ref.errorMessage,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    customText = _useState2[0],
    setCustomText = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var inputRef = (0, _react.useRef)(null);
  var handleOnChange = function handleOnChange(event) {
    var _event$target;
    setCustomText(event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };
  var onFocusHandler = function onFocusHandler(event) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(event);
  };
  var onBlurHandler = function onBlurHandler(event) {
    setTimeout(function () {
      return setIsFocused(false);
    }, 150);
    onBlur === null || onBlur === void 0 || onBlur(event);
  };
  var characterLimitReached = (0, _react.useMemo)(function () {
    return (customText === null || customText === void 0 ? void 0 : customText.length) > (props === null || props === void 0 ? void 0 : props.maxCharacters);
  }, [customText, props === null || props === void 0 ? void 0 : props.maxCharacters]);
  if (customPlaceholder) {
    return /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].relative, {
      width: (props === null || props === void 0 ? void 0 : props.width) || 'auto'
    }, (customText === null || customText === void 0 ? void 0 : customText.length) > 0 || isFocused ? /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, {
      backgroundColor: _colors.Colors.WHITE,
      top: -10,
      left: 24,
      padding: "0 4px",
      width: "auto"
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: hasError ? _colors.Colors.DARK_RED_2 : isFocused ? _colors.Colors.PURE_PURPLE : _colors.Colors.CONTENT_TEXT_TERTIARY
    }, props === null || props === void 0 ? void 0 : props.placeholder)) : null, /*#__PURE__*/_react["default"].createElement(InputBox, _extends({
      "data-test-id": dataTestId,
      ref: inputRef,
      onFocus: onFocusHandler,
      autoFocus: autoFocus,
      onBlur: onBlurHandler,
      value: value,
      onChange: handleOnChange,
      onClick: onClick,
      type: type,
      className: "sui-input",
      "data-test-class": "sui-input",
      theme: theme
    }, props, {
      border: characterLimitReached || hasError ? "1px solid ".concat(_colors.Colors.DARK_RED_2) : '',
      focusBorder: characterLimitReached || hasError ? "1px solid ".concat(_colors.Colors.DARK_RED_2, " !important") : '',
      autoComplete: "off",
      placeholder: isFocused ? "" : props.placeholder
    })), icon ? /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, {
      top: 18,
      right: 24
    }, icon) : null, props !== null && props !== void 0 && props.maxCharacters && isFocused ? /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      margin: "4px 0 0 0",
      fullWidth: true,
      justifyContent: characterLimitReached ? _types2.FlexProps.JustifyContent.SPACE_BETWEEN : _types2.FlexProps.JustifyContent.FLEX_END,
      alignItems: _types2.FlexProps.AlignItems.CENTER
    }, characterLimitReached ? /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      alignItems: _types2.FlexProps.AlignItems.CENTER,
      gap: 4
    }, /*#__PURE__*/_react["default"].createElement(_exclamationIcon["default"], null), /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: _colors.Colors.DARK_RED_2
    }, "Character limit reached")) : null, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], null, /*#__PURE__*/_react["default"].createElement(_Text["default"].CAPTION, {
      letterSpacing: 0.4,
      color: characterLimitReached ? _colors.Colors.DARK_RED_2 : _colors.Colors.CONTENT_TEXT_TERTIARY
    }, customText === null || customText === void 0 ? void 0 : customText.length, "/", props === null || props === void 0 ? void 0 : props.maxCharacters, " characters"))) : null, errorMessage && hasError ? /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      margin: "4px 0 0 10px",
      fullWidth: true,
      justifyContent: _types2.FlexProps.JustifyContent.FLEX_START,
      alignItems: _types2.FlexProps.AlignItems.CENTER
    }, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], null, /*#__PURE__*/_react["default"].createElement(_Text["default"].FOOTER, {
      letterSpacing: 0.4,
      color: _colors.Colors.TEXT_ERROR
    }, errorMessage))) : null, children);
  }
  return /*#__PURE__*/_react["default"].createElement(InputBox, _extends({
    "data-test-id": dataTestId,
    onFocus: onFocus,
    autoFocus: autoFocus,
    onBlur: onBlur,
    value: value,
    onChange: onChange,
    onClick: onClick,
    type: type,
    className: "sui-input",
    "data-test-class": "sui-input",
    theme: theme
  }, props, {
    autoComplete: "off",
    "data-sentry-element": "InputBox",
    "data-sentry-component": "Input",
    "data-sentry-source-file": "index.tsx"
  }));
};
Input[_types.InputTypes.TEXT] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Input, _extends({
    type: _types.InputTypes.TEXT
  }, props));
};
Input[_types.InputTypes.PASSWORD] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Input, _extends({
    type: _types.InputTypes.PASSWORD
  }, props));
};
var _default = exports["default"] = Input;